<div class="send-bulletin-container">
  <div class="section-header">
    <div class="header-icon">📢</div>
    <div>
      <h3>Deployment Bulletin</h3>
      <p class="section-desc">Send a real-time notification with countdown to all users with active sessions.</p>
    </div>
  </div>

  <!-- Presets -->
  <div class="preset-row">
    <span class="preset-label">Quick presets:</span>
    <button *ngFor="let preset of presets"
      class="preset-btn"
      (click)="applyPreset(preset)"
      [title]="preset.message">
      {{ preset.label }}
    </button>
  </div>

  <!-- Message input -->
  <div class="form-group">
    <label class="form-label" for="bulletinMessage">Bulletin Message</label>
    <textarea
      id="bulletinMessage"
      class="form-textarea"
      rows="4"
      [(ngModel)]="message"
      placeholder="Enter the message all users will see..."
      maxlength="500">
    </textarea>
    <div class="char-count">{{ message.length }} / 500</div>
  </div>

  <!-- Countdown -->
  <div class="form-group">
    <label class="form-label" for="countdown">Countdown (minutes)</label>
    <div class="countdown-input-row">
      <input
        id="countdown"
        type="number"
        class="form-input"
        [(ngModel)]="countdownMinutes"
        min="1"
        max="60"
        step="1" />
      <span class="countdown-hint">Min: 1 min · Max: 60 min</span>
    </div>
  </div>

  <!-- Action -->
  <div class="action-row">
    <button
      class="send-btn"
      (click)="promptSend()"
      [disabled]="isSending || !message.trim()">
      <span *ngIf="!isSending">🚀 Send Bulletin to All Users</span>
      <span *ngIf="isSending">Sending...</span>
    </button>
  </div>

  <!-- Confirmation dialog -->
  <div class="confirm-overlay" *ngIf="showConfirm">
    <div class="confirm-card">
      <h4>⚠️ Confirm Broadcast</h4>
      <p>This will immediately display a notification overlay with a <strong>{{ countdownMinutes }} minute</strong> countdown to <strong>every user</strong> currently using the application.</p>
      <p class="confirm-message">"{{ message }}"</p>
      <div class="confirm-actions">
        <button class="cancel-btn" (click)="cancelSend()">Cancel</button>
        <button class="confirm-btn" (click)="confirmSend()">Yes, Send Now</button>
      </div>
    </div>
  </div>

  <!-- Result message -->
  <div *ngIf="lastResult"
    class="result-msg"
    [class.result-success]="lastResult.success"
    [class.result-error]="!lastResult.success">
    {{ lastResult.text }}
  </div>
</div>
